import Player from "@vimeo/player";

const SELECTORS = {
  container: ".js-container-with-video",
  video: ".js-container-video",
};

const CSS = {
  videoPlaying: "is-playing-video",
  videoFailed: "has-failed-video",
};

const timeout = 30;
const maxRetries = 300;

const hasExceededRetry = (retryCount: number) => {
  return retryCount > maxRetries;
};

const instance = ($container: HTMLElement) => {
  let retryCount = 0;
  const $vimeoIframe = $container.querySelector<HTMLIFrameElement>(
    SELECTORS.video,
  );

  if (!$vimeoIframe) {
    return;
  }

  let vimeoPlayer: Player;

  try {
    vimeoPlayer = new Player($vimeoIframe);
  }
  catch (error) {
    console.error(
      `Failed to initialize Vimeo player, URL: ${$vimeoIframe.src}`,
    );
    console.error(error);
    return;
  }

  if (!vimeoPlayer) {
    return;
  }

  async function checkVimeoPaused() {
    const paused = await vimeoPlayer.getPaused();

    if (paused) {
      retryCount++;

      if (hasExceededRetry(retryCount)) {
        $container.classList.add(CSS.videoFailed);
        return;
      }

      setTimeout(() => checkVimeoPaused(), timeout);
      return;
    }

    $container.classList.add(CSS.videoPlaying);
  }

  setTimeout(() => checkVimeoPaused(), timeout);
};

export default () => {
  const $containers = document.querySelectorAll<HTMLElement>(
    SELECTORS.container,
  );

  $containers.forEach(($container) => {
    instance($container);
  });
};
